/**
 * Dialog utility to enable more accessible and feature-rich dialogs.
 * This class is a work in progress.
 */
import Player from "@vimeo/player";
class Dialog {
    constructor(element) {
        this.el = element;
        this.dialogName = this.el.getAttribute("data-dialog");
        this.dialogContent = this.el.querySelector("[data-dialog-content]");
        this.type = this.el.dataset.dialogType;
        this.templateId = this.el.dataset.template;
        this.iframe = this.el.querySelector("iframe");

        this.init();
    }

    init() {
        const dialogShowElements = document.querySelectorAll(
            "[data-dialog-show='" + this.dialogName + "']",
        );

        const dialogHideElements =
            this.el.querySelectorAll("[data-dialog-hide]");

        dialogShowElements.forEach((element) => {
            element.addEventListener("click", (e) => {
                this.open(e);
            });
        });

        dialogHideElements.forEach((element) => {
            element.addEventListener("click", (e) => {
                this.close(e);
            });
        });

        this.setScrollbarWidth();
    }

    open(e) {
        this.fixBody();

        document.body.classList.add("dialog-is-open");
        document.body.classList.add(`${this.dialogName}-dialog-is-open`);

        this.el.setAttribute("aria-hidden", "false");

        if (this.dialogContent) {
            const template = document.getElementById(this.templateId);
            if (template && template.content) {
                const clone = document.importNode(template.content, true);
                this.dialogContent.innerHTML = ""; // Clear existing content
                this.dialogContent.appendChild(clone); // Insert cloned content
            } else {
                console.error(`Template with ID ${this.templateId} not found.`);
            }
        }

        if (this.el.tagName == "DIALOG") {
            this.el.showModal();
        }

        if (this.dialogName == "featuredVideoDialog") {
            if (!this.iframe) return;

            if (this.iframe.src.includes("vimeo")) {
                const vimeoPlayer = new Player(this.iframe);
                vimeoPlayer.play();
            }
        }
    }

    close() {
        if (this.dialogContent) {
            this.dialogContent.innerHTML = "";
        }

        this.unfixBody();

        document.body.classList.remove("dialog-is-open");
        document.body.classList.remove(`${this.dialogName}-dialog-is-open`);

        this.el.setAttribute("aria-hidden", "true");
        this.el.setAttribute("data-type", "");

        if (this.el.tagName == "DIALOG") {
            this.el.close();
        }

        if (this.iframe) {
            const src = this.iframe.src;
            this.iframe.src = src;
        }
    }

    fixBody() {
        document.documentElement.classList.add("no-scroll");
    }

    unfixBody() {
        document.documentElement.classList.remove("no-scroll");
    }

    setScrollbarWidth() {
        // Use this to stop elements jumping when dialog is opened
        document.documentElement.style.setProperty(
            "--scrollbar-width",
            window.innerWidth - document.documentElement.clientWidth + "px",
        );
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const dialogElements = document.querySelectorAll("[data-dialog]");

    dialogElements.forEach((element) => {
        new Dialog(element);
    });
});
